export * from './Persona';
export * from './Persona.base';
export * from './Persona.types';
export * from './PersonaCoin/index';
export * from './PersonaConsts';
// Exporting in case someone would like to track the current color of a persona
export { getPersonaInitialsColor } from './PersonaInitialsColor';
//# sourceMappingURL=index.js.map